import React, { useState } from 'react';
import { Field } from 'formik';
import { Form } from 'formik';
import { Formik } from 'formik';

const OrderDetailsInvestigationResults = ({results, type, progressPending}) => {

    const parsedResults = results ? JSON.parse(results) : '';

    return (
        !progressPending && <Formik>
            <Form>
                <div className='mb-3'>
                    <label>Investigation Type: </label><span> {parsedResults.resultType}</span>
                </div>
            { (type?.includes('Insurance Investigation') || type?.includes('Insurance Claim History')) &&
                <div className='mb-3'>
                    <label>Investigation Status: </label><span> {parsedResults.resultStatus}</span>
                </div>
            }
                <fieldset disabled={true}>
                    <label>Details</label>
                    <br />
                    <div className="form-field-wrapper">
                        {/* <label>Details</label> */}
                        <Field id='results' name='results' as='textarea' rows='15' value={parsedResults.results} />
                    </div>
                </fieldset>
            </Form>
        </Formik>
    )
};

export default OrderDetailsInvestigationResults;